<template>
  <section style="padding: 1.5em">
    <div class="row">
      <div class="col-md-12">
        <div v-if="loading" class="loader"></div>
        <div v-else>
          <h5><small>CSS IDs</small></h5>
          <table id="node" class="table table-bordered">
            <thead class="light">
            <tr>
              <th width="50%" scope="col"  class="text-center">ID</th>
              <th  width="50%" scope="col"  class="text-center" @click="sortBy('count')">
                Count
                <span v-if="sortKey === 'count'">{{ sortOrder === 'asc' ? '⬆️' : '⬇️' }}</span>
              </th>
            </tr>
            </thead>
            <tbody>
              <tr v-for="item in sortedCSSItems" :key="item.name">
                <td  class="text-center">{{ item.name }}</td>
                <td  class="text-center">{{ item.count }}</td>
              </tr>
            </tbody>
          </table>
          <div v-if="!cssIdsList.length" class="text-center text-danger">No data available.</div>
          <h5 class="mt-20"><small>JS IDs</small></h5>
          <table id="node" class="table table-bordered">
            <thead class="light">
            <tr>
              <th width="50%" scope="col"  class="text-center">ID</th>
              <th  width="50%" scope="col"  class="text-center" @click="sortBy('count')">
                Count
                <span v-if="sortKey === 'count'">{{ sortOrder === 'asc' ? '⬆️' : '⬇️' }}</span>
              </th>
            </tr>
            </thead>
            <tbody>
              <tr v-for="item in sortedJSItems" :key="item.name">
                <td  class="text-center">{{ item.name }}</td>
                <td  class="text-center">{{ item.count }}</td>
              </tr>
            </tbody>
          </table>
          <div v-if="!jsIdsList.length" class="text-center text-danger">No data available.</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {db} from "@/firebase/init";

export default {
  name: "IDsList",
  data () {
    return {
      cssIdsList: [],
      jsIdsList: [],
      loading: false,
      sortKey: 'count',    // Current sort key ('id' or 'count')
      sortOrder: 'desc'  // Current sort order ('asc' or 'desc')
    }
  },
  computed: {
    sortedCSSItems() {
      return this.cssIdsList.slice().sort((a, b) => {
        // Sort by the current sort key (count)
        if (this.sortKey === 'count') {
          const compareA = a.count;
          const compareB = b.count;
          return this.sortOrder === 'asc' ? compareA - compareB : compareB - compareA;
        }
        return 0;
      });
    },
    sortedJSItems() {
      return this.jsIdsList.slice().sort((a, b) => {
        // Sort by the current sort key (count)
        if (this.sortKey === 'count') {
          const compareA = a.count;
          const compareB = b.count;
          return this.sortOrder === 'asc' ? compareA - compareB : compareB - compareA;
        }
        return 0;
      });
    }
  },
  mounted() {
    this.getCSSIDs()
    this.getJSIDs()
  },
  methods: {
    async getCSSIDs() {
      this.loading = true
      this.cssIdsList = []
      try {
        const res = await db.collection('idsCollection').doc('perfmatters-css').get()
        if (res.exists) {
          const ids = res.data().ids || {};
          for (const idObj in ids) {
            console.log(idObj, ids[idObj])
            this.cssIdsList.push({
              name: idObj,
              count: ids[idObj]
            })
          }
        }
      } catch (e) {
        console.log('error', e.toString())
      }
      this.loading = false
    },
    async getJSIDs() {
      this.loading = true
      this.jsIdsList = []
      try {
        const res = await db.collection('idsCollection').doc('perfmatters-js').get()
        if (res.exists) {
          const ids = res.data().ids || {};
          for (const idObj in ids) {
            console.log(idObj, ids[idObj])
            this.jsIdsList.push({
              name: idObj,
              count: ids[idObj]
            })
          }
        }
      } catch (e) {
        console.log('error', e.toString())
      }
      this.loading = false
    },
    sortBy(key) {
      if (this.sortKey === key) {
        // Toggle sort order if the same key is clicked
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        // Set new sort key and reset order to ascending
        this.sortKey = key;
        this.sortOrder = 'asc';
      }
    }
  }
}
</script>


<style scoped>

</style>